<practica-navbar></practica-navbar>
<ngx-loading-bar [includeSpinner]="false" color="#FACE49" height="3px"></ngx-loading-bar>
<div id="scroll-nav-top" class="main-content mt-5">
    <div class="container h-100 w-100">
        <router-outlet></router-outlet>
    </div>
</div>
<practica-footer></practica-footer>

